<template>
    <v-layout class="mt-3">
        <input type="file" style="display: none" ref="file" accept="image/*" @change="onFilePicked"/>
        <v-flex xs12>
            <div class="img-container">
                <v-img :src="imageUrl" :height="height || 220" class="img" contain>
                    <v-btn absolute top right small icon color="error" style="top: -12px; right: 170px" dark @click.stop="resetFile" v-if="imageUrl">
                        <v-icon small>fas fa-times</v-icon>
                    </v-btn>
                    <v-btn absolute top right small round color="black" style="top: -12px" dark @click.stop="pickFile">
                        {{ imgLabel }}
                    </v-btn>
                    <div class="no_signature" v-if="!imageUrl">
                        Aún no subes tu firma.
                        <br>
                        Recuerda utilizar una imagen con fondo blanco.
                    </div>
                </v-img>
            </div>
        </v-flex>
        <div>
            <small class="accent--text" v-if="maxSizeExceeded">Tamaño excedido (max. {{ maxSize }}mb.)</small>
        </div>
    </v-layout>

</template>

<script>
export default {
    props: ['default', 'size', 'imgLabel', 'maxSize', 'height', 'rounded'],
    data() {
        return {
            imageName: '',
            imageUrl: this.default || '',
            imageFile: ''
        }
    },
    mounted() {
        const vm = this
        if (vm.default) {
            vm.imageUrl = vm.default
        }
    },
    methods: {
        pickFile() {
            this.$refs.file.click()
        },
        resetFile() {
            this.imageUrl = ''
            this.imageFile = null
            this.$refs.file.value = ''
            this.$emit('change', null)
            this.$emit('delete', true)
        },
        onFilePicked(e) {
            const files = e.target.files
            if (files[0] !== undefined) {
                this.imageName = files[0].name
                if (this.imageName.lastIndexOf('.') <= 0) {
                    return
                }
                const fr = new FileReader()
                fr.readAsDataURL(files[0])
                fr.addEventListener('load', () => {
                    this.imageUrl = fr.result
                    this.imageFile = files[0]
                    this.$emit('change', files[0])
                })

                return
            }

            this.imageName = ''
            this.imageFile = ''
            this.imageUrl = ''

        }
    },
    computed: {
        valid() {
            const vm = this
            if (vm.maxSizeExceeded) return false
            return true
        },
        maxSizeExceeded() {
            const vm = this
            return vm.maxSize && vm.fileSize > Number(vm.maxSize)
        },
        fileSize() {
            const vm = this
            return vm.imageFile && (vm.imageFile.size / 1024 / 1024).toFixed(2) || 0
        }
    },
    watch: {
        valid(val) {
            this.$emit('change:validation', val)
        },
        default(val) {
            if (val) this.imageUrl = val
        }
    }
}
</script>

<style scoped>
.v-avatar img {
    object-fit: cover;
}

.img-container {
    border-radius: 8px;
    border: 1px solid #757575;
    background-color: #F5F5F5;
}

.img {
    border-radius: 8px;
    overflow: visible;
    display: flex;
    align-items: center;
}

.no_signature {
    text-align: center;
    color: #666666;
    font-size: 13px;
    line-height: 15px;
}

</style>